* {
  box-sizing: border-box;
}
:host {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: $xp-ref-spacing-2;
}

.label {
  position: relative;
  font: $xp-ref-font-paragraph-paragraph-small;
  color: $xp-ref-color-text-forms-label;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text {
  font: $xp-ref-font-paragraph-paragraph-small;
  color: $xp-ref-color-text-forms-label;
  overflow: visible;
}

.close-icon {
  position: absolute;
  display: none;
  transform: translateX(-50%);
  transform: translateY(+50%);
  right: 15px;
  bottom: 50%;
  font-size: 20px;
  cursor: pointer;
  color: $xp-ref-color-text-default-medium;
}

.any-icon {
  position: absolute;
  display: block;
  transform: translateX(-50%);
  transform: translateY(+50%);
  right: 15px;
  bottom: 50%;
  font-size: 20px;
  color: $xp-ref-color-text-default-medium;
}

.input-row.is-focused .close-icon {
  display: block;
}

.input-row {
  box-sizing: border-box;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  input[type="text"] {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid $xp-ref-color-border-heavy;
    background-color: $xp-ref-color-background-component-high-emphasis;
    height: $xp-ref-size-9;
    font: $xp-ref-font-paragraph-paragraph-short;
    color: $xp-ref-color-text-forms-placeholder;
    padding: $xp-ref-spacing-1 $xp-ref-spacing-8 $xp-ref-spacing-1 $xp-ref-spacing-3;

    &:focus {
      outline: 3px solid $xp-ref-color-border-focus-default;
    }
  }
}

.input-row.is-error {
  width: 100%;
  position: relative;
  input[type="text"] {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid $xp-ref-color-semantic-on-critical;
    background-color: $xp-ref-color-semantic-critical-low-emphasis;
    height: $xp-ref-size-9;
    font: $xp-ref-font-paragraph-paragraph-short;
    color: $xp-ref-color-semantic-on-critical;
    padding: $xp-ref-spacing-1 $xp-ref-spacing-8 $xp-ref-spacing-1 $xp-ref-spacing-3;
  }
}

.input-row.is-error + .text {
  color: $xp-ref-color-semantic-on-critical;
  overflow: visible;
}

.error-icon {
  font-size: 20px;
  color: $xp-ref-color-semantic-on-critical;
}

input[type="text"]:disabled {
  background-color: $xp-ref-color-state-disabled;
  color: $xp-ref-color-state-on-disabled;
}

.error {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: $xp-ref-spacing-1;
}

.link {
  text-decoration: underline;
  cursor: pointer;
}
